export function classNameJoiner(classes: string[]) {
    return classes.join(' ');
}